import React from "react";

export default class SettingsAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      smsNewPhotoshoot: props.currentUser.sms_new_photoshoot !== false
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle(field) {
    const newValue = !this.state[field];
    this.setState({ [field]: newValue });

    const formData = new FormData();
    formData.append("user[sms_new_photoshoot]", newValue);

    this.props.updateProfile(formData, this.props.currentUser.id)
      .then(() => this.props.showToast("Alert preferences updated"))
      .catch(() => this.props.showToast("Error updating preferences"));
  }

  render() {
    const { smsNewPhotoshoot } = this.state;

    return (
      <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences">
          <div className="settingsComponentHeading">Alert Preferences</div>
          <div className="settingsGroup">
            <div className="settingsPreferencesGroup1">
              <div className="settingsCompanyInput">
                <span className="formLabel">SMS - New / Updated Photoshoots</span>
                <div
                  className={`toggle-switch ${smsNewPhotoshoot ? 'active' : ''}`}
                  onClick={() => this.handleToggle("smsNewPhotoshoot")}
                >
                  <div className="toggle-knob"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
